var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.bind},[_c('img',{attrs:{"src":(_vm.$cdnUrl + "/offlinePay/button6.png"),"alt":""},on:{"click":function($event){return _vm.$emit('showBindToast')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }